import { render } from "./ModalSprinklers.vue?vue&type=template&id=12b5abac&scoped=true"
import script from "./ModalSprinklers.vue?vue&type=script&lang=js"
export * from "./ModalSprinklers.vue?vue&type=script&lang=js"

import "./ModalSprinklers.vue?vue&type=style&index=0&id=12b5abac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b5abac"]])

export default __exports__